const goBackButtonTarget = '.wm-goBackButton';
const goBackLinkTarget = '.wm-goBackLink';
const domainName = larry.domain;
jQuery(document).on('ready', function () {
    jQuery(goBackButtonTarget).on('click', function (e) {
        e.preventDefault();
        let docReferrer = document.referrer;
        let currentURL = window.location.href;
        if (docReferrer.includes(domainName) && docReferrer != currentURL) {
            history.back();
        }
        else
            window.location.href = larry.rootUrl;
    });
    jQuery(goBackLinkTarget).on('click', function (e) {
        e.preventDefault();
        let docReferrer = document.referrer;
        let currentURL = window.location.href;
        if (docReferrer.includes(domainName) && docReferrer != currentURL) {
            history.back();
        }
        else
            window.location.href = larry.rootUrl;
    });
});
